import React from 'react';
import Button from '@mui/material/Button';
import NotListedLocationIcon from '@mui/icons-material/NotListedLocation';
import LocationOnIcon from '@mui/icons-material/LocationOn';

export default class MarkButton extends React.Component {
    constructor(props) {
        super(props);
        this.onMouseClick = this.onMouseClick.bind(this);
        this.state = {
            color: props.mark ? 'secondary' : 'action',
            mark: props.mark,
            disable: false
        }
    }
    onMouseEnter() {
        this.setState({ color: 'primary' });
    }
    onMouseLeave(arg) {
        this.setState({ color: arg ? 'secondary' : 'action' });
    }
    onMouseClick() {
        this.setState({ mark: !this.state.mark });
        this.setState({ disable: true });
        this.onMouseLeave(!this.state.mark);
        setTimeout(() => this.setState({ disable: false }), 2000);
        return this.props.onMouseClick();
    }
    render() {
        return (
            <Button data-tip data-for="markTip" data-delay-hide={1000} disabled={this.state.disable}
                style={{ maxWidth: "20px", maxHeight: "20px", minWidth: "15px", marginRight: "0px", marginLeft: "0px", padding: "0px,0px" }}
                onClick={(e) => { e.stopPropagation(); this.onMouseClick(); }}
                onMouseEnter={() => this.onMouseEnter()}
                onMouseLeave={() => this.onMouseLeave(this.state.mark)}
            >{this.state.mark ? (<LocationOnIcon color={this.state.color} fontSize="small" />) :
                (<NotListedLocationIcon color={this.state.color} fontSize="small" />)}
            </Button>
        );
    }
}